/**
 * 配置后端
 */

import { domainReg } from 'utils/regex';

// http://api.finlogixtest.com/v1/admin/login?email=steven.hu@zerologix.com&password=acy11111111&captcha=jh4hn
// "http://api.cloudhubpanellocal.com/api/v1"

const baseUrl = process.env.__API_URL__;
const socketPort = process.env.__SOCKET_PORT__;
const socketDomain = process.env.__SOCKET_URL__;
const appName = process.env.__APP_NAME__;
const apiDomain = domainReg.exec(baseUrl)[0];
const socketUrl = `${socketDomain}:${socketPort}`;
const socketPrefix = process.env.__SOCKET_PREFIX__;

export { baseUrl, socketUrl, apiDomain, appName, socketPrefix };



// WEBPACK FOOTER //
// ./src/config/env.config.js